import {NetworkToggleValue} from "../../core/constants";
import {FetcherMiddleware} from "../../core/network/fetcher/Fetcher";
import {fetchJSONMiddleware} from "../../core/network/fetcher/fetcherUtils";
import PeraApi from "../../core/network/pera-api/peraApi";
import tinymanAnalyticsApiManager from "../../core/network/tinyman-analytics-api/TinymanAnalyticsApi";
import {AppStateAccountData} from "../../wallet/account/accountTypes";
import {DEFAULT_VERIFIED_ASSETS} from "../util/assetConstants";
import {
  AssetListItemData,
  CurrentAssetPrices,
  ListAssetRequestParams,
  PeraLabeledAsset,
  VerifiedAssets
} from "../util/assetModels";
import {
  filterInAssetsThatCanBePoolConstituentMiddleware,
  filterOutNonLiquidAssetsMiddleware,
  mapAssetToAssetListItemDataMiddleware
} from "./assetApi.utils";

const assetApi = {
  getCurrentAssetPrices(options?: {responseMiddlewares?: FetcherMiddleware[]}) {
    return tinymanAnalyticsApiManager.fetcher.default.run<CurrentAssetPrices>(
      {method: "GET", responseMiddlewares: options?.responseMiddlewares},
      "/assets/prices/"
    );
  },

  listPeraLabeledAssets(selectedPreferredNetwork: NetworkToggleValue) {
    return PeraApi.run<VerifiedAssets>(
      {
        method: "GET",
        headers: {
          "algorand-network":
            selectedPreferredNetwork === "mainnet" ? "mainnet" : "testnet"
        },
        responseMiddlewares: [
          fetchJSONMiddleware,
          (data: ListRequestResponse<PeraLabeledAsset>) => {
            const results = data.results.reduce<VerifiedAssets>((labeledAssets, item) => {
              labeledAssets[item.asset_id] = item;

              return labeledAssets;
            }, DEFAULT_VERIFIED_ASSETS);

            return Promise.resolve(results);
          }
        ]
      },
      "/labeled-assets/"
    );
  },

  listAssets(
    params: ListAssetRequestParams,
    account?: AppStateAccountData | null,
    accountAssets?: AssetListItemData[],
    responseMiddlewares?: FetcherMiddleware<any, any>[]
  ) {
    return tinymanAnalyticsApiManager.fetcher.default.run<
      ListRequestResponse<AssetListItemData>
    >(
      {
        method: "GET",
        params,
        responseMiddlewares: responseMiddlewares || [
          fetchJSONMiddleware,
          mapAssetToAssetListItemDataMiddleware(account || null, accountAssets || [])
        ]
      },
      "/assets/"
    );
  },

  listSwapAssets(
    params: ListAssetRequestParams,
    account?: AppStateAccountData | null,
    accountAssets?: AssetListItemData[]
  ) {
    return this.listAssets(params, account, accountAssets, [
      fetchJSONMiddleware,
      filterOutNonLiquidAssetsMiddleware(),
      filterInAssetsThatCanBePoolConstituentMiddleware(),
      mapAssetToAssetListItemDataMiddleware(account || null, accountAssets || [])
    ]);
  }
};

export default assetApi;
